import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Injector, enableProdMode, isDevMode} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { AppRoutingModule } from 'src/app/app.routes';
import {MessageService} from 'primeng/api'
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';

import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

import { MenuComponent } from './components/menu/menu.component';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SidenavCellComponent } from './components/dashboard/sidenav-cell/sidenav-cell.component';

/* de tiritas.module */
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ConfirmationService} from 'primeng/api';

import { PipeModule } from './pipes/pipe.module';

import { CheckboxModule } from 'primeng/checkbox';
import {AccordionModule} from 'primeng/accordion';

import {CardModule} from 'primeng/card';

import { FileUploadModule } from 'primeng/fileupload';
import {ButtonModule} from 'primeng/button';
import {SlideMenuModule} from 'primeng/slidemenu';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MiPerfilComponent } from './pages/mi-perfil/mi-perfil.component';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { AppInjector } from './injector';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    PageNotFoundComponent,
    DashboardComponent,
    LoginComponent,
    DashboardComponent,
    SidenavCellComponent,
    MiPerfilComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TieredMenuModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastModule,
    MessagesModule,
    TableModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    SliderModule,
    CalendarModule,
    RadioButtonModule,
    InputSwitchModule,
    ConfirmDialogModule,
    FormsModule,
    PipeModule,
    CheckboxModule,
    AccordionModule,
    FileUploadModule,
    ButtonModule,
    CardModule,
    SlideMenuModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production && !isDevMode() })
  
  ],
  providers: [
    MessageService,
    ConfirmationService,
    CookieService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports:[

  ]
})
export class AppModule {
  constructor(injetor: Injector) {
    AppInjector.setInjector(injetor);
  }
}
